import { groq } from 'next-sanity';

const siteSettingsQuery = groq`
  *[_id == "siteSettings"][0] {
  ...,
  "logo": logo.asset->{url, "dimensions": metadata.dimensions}
}
`;

export default siteSettingsQuery;
